/* Swatches nativos del PDP (<variant-picker>):
   (1) inyecta el NOMBRE del color debajo de cada swatch,
   (2) convierte la fila en UNA sola linea scrollable con flechas (como Swatch King),
   (3) FALLBACK: en productos cuya opcion Color se renderiza como BOTONES de texto
       (sin metafield shopify.color-pattern, p.ej. CORE-T, Duke), construye swatches
       de imagen a partir de las fotos de variante. Asi no dependemos de la app. */
(function () {
  var colorImgMap = null;       // { "Blanco": "https://...png", ... } o null
  var mapTried = false;

  // ---- mapa color -> imagen de variante (una sola peticion, cacheada) ----
  function buildColorImageMap(product) {
    if (!product || !product.options || !product.variants) return null;
    var colorOpt = null, idx = 0;
    for (var i = 0; i < product.options.length; i++) {
      var o = product.options[i];
      var nm = (o && o.name) ? o.name : o;
      if (/colou?r/i.test(nm)) { colorOpt = o; idx = i; break; }
    }
    if (!colorOpt) return null;
    var pos = (colorOpt && colorOpt.position) ? colorOpt.position : (idx + 1);
    var map = {};
    for (var j = 0; j < product.variants.length; j++) {
      var v = product.variants[j];
      var c = v['option' + pos];
      if (c && !map[c] && v.featured_image && v.featured_image.src) {
        map[c] = v.featured_image.src;
      }
    }
    return map;
  }

  function loadColorImgMap(cb) {
    if (mapTried) { cb(colorImgMap); return; }
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) { mapTried = true; cb(null); return; }
    fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { colorImgMap = buildColorImageMap(p); })
      .catch(function () { colorImgMap = null; })
      .then(function () { mapTried = true; cb(colorImgMap); });
  }

  function hiRes(src) {
    return src.split('?')[0] + '?width=400';
  }

  // ---- FALLBACK: fieldset de Color en-botones -> swatches de imagen ----
  function upgradeColorButtons(map) {
    if (!map) return;
    var fieldsets = document.querySelectorAll(
      'variant-picker fieldset.variant-option--buttons:not(.variant-option--swatches)'
    );
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      if (fs.dataset.swUpgraded) continue;
      var oid = fs.getAttribute('data-option-id') || '';
      var legend = fs.querySelector('legend');
      var isColor = /colou?r/i.test(oid) || (legend && /colou?r/i.test(legend.textContent));
      if (!isColor) continue;

      var labels = fs.querySelectorAll(':scope > .variant-option__button-label');
      if (!labels.length) continue;

      // solo actualizamos si TODOS los valores tienen imagen (evita estados a medias)
      var data = [], ok = true;
      for (var k = 0; k < labels.length; k++) {
        var input = labels[k].querySelector('input');
        var name = input ? (input.getAttribute('aria-label') || input.value) : '';
        var src = name ? map[name] : null;
        if (!src) { ok = false; break; }
        data.push({ label: labels[k], src: src });
      }
      if (!ok) continue;

      for (var d = 0; d < data.length; d++) {
        var label = data[d].label;
        if (!label.querySelector('.swatch')) {
          var sp = document.createElement('span');
          sp.className = 'swatch swatch--unscaled';
          sp.style.setProperty('--swatch-background', 'url(' + hiRes(data[d].src) + ')');
          label.insertBefore(sp, label.firstChild);
        }
        label.classList.add('variant-option__button-label--has-swatch');
      }
      fs.classList.add('native-swatch-upgraded');
      fs.dataset.swUpgraded = '1';
    }
  }

  // ---- nombre del color debajo de cada swatch ----
  function injectNames() {
    var labels = document.querySelectorAll(
      'variant-picker .variant-option__button-label--has-swatch'
    );
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      if (label.querySelector('.native-swatch-name')) continue;
      var input = label.querySelector('input');
      var name = input ? input.getAttribute('aria-label') || input.value : '';
      if (!name) continue;
      var span = document.createElement('span');
      span.className = 'native-swatch-name';
      span.textContent = name;
      label.appendChild(span);
    }
  }

  // ---- fila de una sola linea, scrollable, con flechas ----
  function mkArrow(dir, glyph, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'native-swatch-arrow native-swatch-arrow--' + dir;
    b.setAttribute('aria-label', label);
    b.textContent = glyph;
    return b;
  }

  function wire(track, prev, next) {
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.style.display = track.scrollLeft > 4 ? 'flex' : 'none';
      next.style.display = max > 4 && track.scrollLeft < max ? 'flex' : 'none';
    }
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
    });
    track.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    setTimeout(update, 150);
    setTimeout(update, 600);
  }

  function buildScrollers() {
    var fieldsets = document.querySelectorAll(
      'variant-picker fieldset.variant-option--swatches, variant-picker fieldset.native-swatch-upgraded'
    );
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var labels = fs.querySelectorAll(':scope > .variant-option__button-label--has-swatch');
      if (!labels.length) continue; // ya envuelto, o sin swatches

      // quitar el boton nativo "ver mas" si existe
      var more = fs.querySelector('[slot="more"], .hidden-swatches__count');
      if (more) {
        var moreLi = more.closest('li');
        (moreLi || more).remove();
      }

      var row = document.createElement('div');
      row.className = 'native-swatch-row';
      var track = document.createElement('div');
      track.className = 'native-swatch-track';
      for (var j = 0; j < labels.length; j++) track.appendChild(labels[j]);
      row.appendChild(track);
      var prev = mkArrow('prev', '‹', 'Colores anteriores');
      var next = mkArrow('next', '›', 'Mas colores');
      row.appendChild(prev);
      row.appendChild(next);
      fs.appendChild(row);
      wire(track, prev, next);
    }
  }

  function run() {
    upgradeColorButtons(colorImgMap);
    injectNames();
    buildScrollers();
  }

  // re-ejecuta como mucho una vez por frame (coalesce de rafagas de mutaciones)
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || function (f) { setTimeout(f, 16); })(function () {
      pending = false;
      run();
    });
  }

  // observa el variant-picker: cuando Horizon lo re-renderiza al cambiar de variante,
  // reconstruimos los swatches al instante (sin esperar al timeout = sin parpadeo).
  function observe() {
    var vps = document.querySelectorAll('variant-picker');
    for (var i = 0; i < vps.length; i++) {
      var vp = vps[i];
      if (vp.dataset.swObserved) continue;
      vp.dataset.swObserved = '1';
      new MutationObserver(schedule).observe(vp, { childList: true, subtree: true });
    }
  }

  function boot() {
    loadColorImgMap(function () { run(); observe(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('variant:update', schedule);
  var tries = 0;
  var iv = setInterval(function () {
    run();
    observe();
    if (++tries > 12) clearInterval(iv);
  }, 300);
})();
